import { render, staticRenderFns } from "./RecordCom.vue?vue&type=template&id=7f1e173d&scoped=true"
import script from "./RecordCom.vue?vue&type=script&lang=js"
export * from "./RecordCom.vue?vue&type=script&lang=js"
import style0 from "./RecordCom.vue?vue&type=style&index=0&id=7f1e173d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1e173d",
  null
  
)

export default component.exports